import { useState } from "react";
import { Reveal } from "../components/Reveal";
import { FINDER } from "../data/content";
import { ArrowRight } from "lucide-react";

export const FloorFinder = () => {
  const [active, setActive] = useState(0);

  return (
    <section data-testid="finder-section" id="produkte" className="py-20 lg:py-32">
      <div className="container-blum">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end mb-14">
          <div className="lg:col-span-8">
            <Reveal><p className="overline">Produkte · Orientierungshilfe</p></Reveal>
            <Reveal delay={0.05}>
              <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
                Welcher Boden passt zu mir?
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-4">
            <p className="text-[#6B6B73] leading-relaxed">
              Eine erste Orientierung – die richtige Entscheidung treffen wir gemeinsam
              in einem persönlichen Beratungsgespräch.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Selector list */}
          <div className="lg:col-span-5 flex flex-col gap-3">
            {FINDER.map((f, i) => (
              <button
                key={f.name}
                data-testid={`finder-option-${i}`}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`text-left p-6 border transition-all duration-300 group ${
                  active === i
                    ? "bg-[#2B2B30] border-[#2B2B30] text-white"
                    : "bg-white border-[#E5E0D8] text-[#2B2B30] hover:border-[#2B2B30]"
                }`}
              >
                <div className="flex items-center justify-between gap-4">
                  <div>
                    <span className={`text-xs uppercase tracking-[0.15em] font-display ${active === i ? "text-[#D7C4B1]" : "text-[#D32F2F]"}`}>
                      {f.tag}
                    </span>
                    <h3 className="font-display text-xl font-semibold mt-1">{f.name}</h3>
                    <p className={`mt-2 text-sm leading-relaxed ${active === i ? "text-white/80" : "text-[#6B6B73]"}`}>
                      {f.desc}
                    </p>
                  </div>
                  <ArrowRight className={`w-5 h-5 shrink-0 transition-transform ${active === i ? "translate-x-1" : ""}`} />
                </div>
              </button>
            ))}
          </div>

          {/* Preview image */}
          <div className="lg:col-span-7">
            <div data-testid="finder-preview" className="relative h-full min-h-[380px] overflow-hidden">
              {FINDER.map((f, i) => (
                <img
                  key={f.name}
                  src={f.img}
                  alt={f.name}
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
                    active === i ? "opacity-100" : "opacity-0"
                  }`}
                />
              ))}
              <div className="absolute inset-0 bg-gradient-to-t from-[#2B2B30]/70 to-transparent" />
              <div className="absolute bottom-0 left-0 p-8">
                <h3 className="font-display text-2xl font-bold text-white">{FINDER[active].name}</h3>
                <p className="text-white/80 mt-1 max-w-md">{FINDER[active].desc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
